"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReport = createReport;
exports.deleteReport = deleteReport;
exports.list = list;
exports.reportWatcher = reportWatcher;
exports.retryReport = retryReport;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _services = require("../../../services");
var _variables = require("../variables");
var _variables2 = require("../../Notification/variables");
var _utils = require("../../../utils");
var _helpers = require("@qwkin/helpers");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(reportWatcher);
function createReport(_ref) {
  var payload = _ref.payload,
    meta = _ref.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, _response$data, _response$data2, _response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.ReportService.createReport, payload);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables.CREATE_REPORT_SUCCESS,
            payload: response
          });
        case 6:
          _context.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Report was successfuly requested for creation'
            }
          });
        case 8:
          meta === null || meta === void 0 || meta.callback();
          _context.next = 19;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _response = _context.t0.response;
          _context.next = 16;
          return (0, _effects.put)({
            type: _variables.CREATE_REPORT_FAIL,
            payload: _response
          });
        case 16:
          _context.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data !== void 0 ? _response$data : {}),
              data: _response
            }
          });
        case 18:
          (0, _utils.logErr)((_response$data2 = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data2 !== void 0 ? _response$data2 : {});
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 11]]);
  })();
}
function deleteReport(_ref3) {
  var payload = _ref3.payload,
    meta = _ref3.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var response, _response2$data, _response2$data2, _response2;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.ReportService.deleteReport, payload);
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)({
            type: _variables.DELETE_REPORT_SUCCESS,
            payload: response
          });
        case 6:
          meta === null || meta === void 0 || meta.callback();
          _context2.next = 9;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Report deleted successfully'
            }
          });
        case 9:
          _context2.next = 19;
          break;
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](0);
          _response2 = _context2.t0.response;
          _context2.next = 16;
          return (0, _effects.put)({
            type: _variables.DELETE_REPORT_FAIL,
            payload: _response2
          });
        case 16:
          _context2.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response2$data = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data !== void 0 ? _response2$data : {}),
              data: _response2
            }
          });
        case 18:
          (0, _utils.logErr)((_response2$data2 = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data2 !== void 0 ? _response2$data2 : {});
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 11]]);
  })();
}
function list(_ref5) {
  var payload = _ref5.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var response, _response3$data, _response3$data2, _response3;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.ReportService.listReports, payload);
        case 3:
          response = _context3.sent;
          _context3.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_REPORTS_SUCCESS,
            payload: response
          });
        case 6:
          _context3.next = 16;
          break;
        case 8:
          _context3.prev = 8;
          _context3.t0 = _context3["catch"](0);
          _response3 = _context3.t0.response;
          _context3.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_REPORTS_FAIL,
            payload: _response3
          });
        case 13:
          _context3.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response3$data = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data !== void 0 ? _response3$data : {}),
              data: _response3
            }
          });
        case 15:
          (0, _utils.logErr)((_response3$data2 = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data2 !== void 0 ? _response3$data2 : {});
        case 16:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 8]]);
  })();
}
function retryReport(_ref7) {
  var payload = _ref7.payload,
    meta = _ref7.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response, _response4$data, _response4$data2, _response4;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.ReportService.retryReport, payload);
        case 3:
          response = _context4.sent;
          _context4.next = 6;
          return (0, _effects.put)({
            type: _variables.RETRY_REPORT_SUCCESS,
            payload: response
          });
        case 6:
          meta === null || meta === void 0 || meta.callback();
          _context4.next = 17;
          break;
        case 9:
          _context4.prev = 9;
          _context4.t0 = _context4["catch"](0);
          _response4 = _context4.t0.response;
          _context4.next = 14;
          return (0, _effects.put)({
            type: _variables.RETRY_REPORT_FAIL,
            payload: _response4
          });
        case 14:
          _context4.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response4$data = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data !== void 0 ? _response4$data : {}),
              data: _response4
            }
          });
        case 16:
          (0, _utils.logErr)((_response4$data2 = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data2 !== void 0 ? _response4$data2 : {});
        case 17:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 9]]);
  })();
}
function reportWatcher() {
  return _regenerator["default"].wrap(function reportWatcher$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables.CREATE_REPORT_REQUEST, createReport), (0, _effects.takeLatest)(_variables.DELETE_REPORT_REQUEST, deleteReport), (0, _effects.takeLatest)(_variables.LIST_REPORTS_REQUEST, list), (0, _effects.takeLatest)(_variables.RETRY_REPORT_REQUEST, retryReport)]);
      case 2:
      case "end":
        return _context5.stop();
    }
  }, _marked);
}